import React, { useState } from "react";

const Accordion = ({ title, content }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div>
      <button
        type="button"
        onClick={() => setIsOpen((prev) => !prev)}
        style={{
          display: "flex",
          alignItems: "center",
          gap: "0.5rem",
          background: "none",
          border: "none",
          padding: "0.4rem 0",
          cursor: "pointer",
          fontSize: "1rem",
          fontWeight: 600,
          color: "inherit",
          textAlign: "left",
          width: "100%",
      
        }}
        aria-expanded={isOpen}
      >
        <span
          style={{
            display: "inline-block",
            transition: "transform 0.2s ease-in-out",
            transform: isOpen ? "rotate(90deg)" : "rotate(0deg)",
            fontSize: "0.75rem",
          }}
        >
          ▶
        </span>
        {title}
      </button>
      {isOpen && (
        <div style={{ marginTop: "0.5rem", paddingLeft: "1.25rem" }}>
          {typeof content === "string" ? <p>{content}</p> : content}
        </div>
      )}
    </div>
  );
};

export default Accordion;